import { render, staticRenderFns } from "./TestingData.vue?vue&type=template&id=5cb3e708&"
import script from "./TestingData.vue?vue&type=script&lang=ts&"
export * from "./TestingData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb3e708')) {
      api.createRecord('5cb3e708', component.options)
    } else {
      api.reload('5cb3e708', component.options)
    }
    module.hot.accept("./TestingData.vue?vue&type=template&id=5cb3e708&", function () {
      api.rerender('5cb3e708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/TestingData.vue"
export default component.exports